module.exports = __webpack_public_path__ + "static/media/check.77bfae35.svg";